import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import {
	SubscriptionTransactionQueryParams,
	SubscriptionTransaction,
  DataUpdate
} from "../type";

interface SubscriptionTransactionState {
	subscriptionTransactionList: {
		items: SubscriptionTransaction[];
		total: number;
	};
	subscriptionTransactionDetail: SubscriptionTransaction | null;
}

const initialState: SubscriptionTransactionState = {
	subscriptionTransactionList: { items: [], total: 0 },
	subscriptionTransactionDetail: null,
};

export const subscriptionTransactionSlice = createSlice({
	name: "subscriptionTransaction",
	initialState,
	reducers: {
		setSubscriptionTransactionList: (state, action) => {
			state.subscriptionTransactionList.items = action.payload.data;
			state.subscriptionTransactionList.total = action.payload.total;
		},
		setSubscriptionTransactionDetail: (state, action) => {
			state.subscriptionTransactionDetail = action.payload.data;
		},
	},
});

export const selectSubscriptionTransactionList = (state: RootState) =>
	state.subscriptionTransaction.subscriptionTransactionList;
export const selectSubscriptionTransactionDetail = (state: RootState) =>
	state.subscriptionTransaction.subscriptionTransactionDetail;

export const {
	setSubscriptionTransactionList,
	setSubscriptionTransactionDetail,
} = subscriptionTransactionSlice.actions;

// get list
export interface GetListSubscriptionTransactionPayload {
	query: SubscriptionTransactionQueryParams;
	callback?: (arg: { success: boolean }) => void;
}
export const getListSubscriptionTransactionAsync = createAction(
	"subscriptionTransaction/getListSubscriptionTransactionAsync",
	(payload: GetListSubscriptionTransactionPayload) => ({
		payload,
	}),
);

// get detail
export interface GetSubscriptionTransactionDetailPayload {
	id: number | string;
	callback?: (arg: { success: boolean }) => void;
}
export const getSubscriptionTransactionDetailAsync = createAction(
	"subscriptionTransaction/getSubscriptionTransactionDetailAsync",
	(payload: GetSubscriptionTransactionDetailPayload) => ({
		payload,
	}),
);

//update
export interface UpdateSubscriptionTransactionPayload {
	id: number | string;
	data: DataUpdate;
	callback?: (arg: { success: boolean }) => void;
}
export const updateSubscriptionTransactionAsync = createAction(
	"subscriptionTransaction/updateSubscriptionTransactionAsync",
	(payload: UpdateSubscriptionTransactionPayload) => ({
		payload,
	}),
);



export default subscriptionTransactionSlice.reducer;
